<template>
  <div class="container">
    <div class="info">
      <el-header>个人信息</el-header>
      <el-main>
        <el-row class="info-box">
          <el-col :span="16">
            <el-row class="item">
              <el-col :span="4">姓名：</el-col>
              <el-col :span="20">
                {{ userDetail.name }}
              </el-col>
            </el-row>
            <el-row class="item">
              <el-col :span="4">手机号：</el-col>
              <el-col :span="20">
                {{ userDetail.phone }}
              </el-col>
            </el-row>
            <el-row class="item">
              <el-col :span="4">邮箱：</el-col>
              <el-col :span="20">
                {{ userDetail.email }}
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-main>
      <el-footer>
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-edit"
            size="mini"
            @click="updateInfo"
            >修改个人资料</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-lock"
            size="mini"
            @click="updatePass"
            >修改登录密码</el-button
          >
        </el-row>
      </el-footer>
    </div>
    <!--编辑信息-->
    <el-dialog :visible.sync="centerDialogVisible" width="40%" center>
      <div slot="title" class="title">编辑个人信息</div>
      <div class="updatePass">
        <el-row class="item">
          <el-col :span="4" class="item-left">姓名：</el-col>
          <el-col :span="18">
            <el-input v-model="userName" size="mini" type="text" />
          </el-col>
        </el-row>
        <el-row class="item">
          <el-col :span="4" class="item-left">手机号：</el-col>
          <el-col :span="18">
            <el-input size="mini" type="text" v-model="userPhone" />
          </el-col>
        </el-row>
        <el-row class="item">
          <el-col :span="4" class="item-left">邮箱：</el-col>
          <el-col :span="18">
            <el-input size="mini" type="text" v-model="userEmail" />
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleUpdataInfo"
          >确 定</el-button
        >
        <el-button size="mini" @click="handleCancel">取 消</el-button>
      </span>
    </el-dialog>
    <!--修改密码-->
    <updatePass :outer-visible="outerVisible" @dialogHide="dialogHide" />
  </div>
</template>

<script>
import updatePass from "./component/updatePass";
import { infoMation, updateInfo } from "@/api/user";
import store from "../../store";
export default {
  name: "InfoMation",
  components: {
    updatePass,
  },
  data() {
    return {
      imageUrl: "",
      userName: "",
      centerDialogVisible: false,
      outerVisible: false,
      userPhone: "",
      userEmail: "",
      userId: "",
      userDetail: JSON.parse(sessionStorage.getItem("iwrs_user")),
    };
  },
  methods: {
    dialogHide() {
      this.outerVisible = false;
    },
    updateInfo() {
      this.centerDialogVisible = true;
      infoMation({
        user_id: this.userDetail.id,
      })
        .then((res) => {
          if (res && res.code === 0) {
            this.userName = res.data.name;
            this.userPhone = res.data.phone;
            this.userEmail = res.data.email;
            this.userId = res.data.id;
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleUpdataInfo() {
      const params = {
        name: this.userName,
        phone: this.userPhone,
        email: this.userEmail,
        id: this.userId,
      };
      updateInfo(params)
        .then((res) => {
          console.log(res);
          if (res && res.code === 0) {
            store.dispatch("user/getInfo");
            store.commit('user/SET_NAME',res.data.name)
            this.handleCancel();
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.userDetail = res.data;
            sessionStorage.setItem("iwrs_user", JSON.stringify(res.data));
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleCancel() {
      this.userId = "";
      this.centerDialogVisible = false;
    },
    updatePass() {
      this.outerVisible = true;
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
.info {
  width: 60%;
  box-shadow: 0px 2px 11px 2px rgba(142, 177, 255, 0.4);
  position: absolute;
  top: 50%;
  left: 50%;
  height: 60%;
  -webkit-transform: translateX(-50%) translateY(-50%);
}
.info-box {
  margin-top: 30px;
}
.el-header {
  text-align: center;
  line-height: 60px;
  font-size: 16px;
}
.el-footer {
  text-align: right;
  line-height: 60px;
}
.el-main {
  text-align: center;
  height: 68%;
}
.header {
  border: 1px dashed #d9d9d9;
  width: 113px;
  height: 160px;
  float: right;
  margin-right: 20px;
}
.item {
  padding: 15px 0;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: default !important;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 120px;
  display: block;
}

.title {
  padding: 18px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}
.updatePass {
  background-color: #f0f5ff;
  padding: 20px 30px;
}
.item-left {
  text-align: right;
  line-height: 26px;
}
</style>
<style>
.el-dialog__header {
  padding: 0px;
}
</style>
